import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SocialMarketPartnersState } from "./types";
import { ErrorType } from "@/shared/types";
import { fetchTradingPartners } from "./social-market-partners-thunk";

const initialState: SocialMarketPartnersState = {
    partners: [],
    isLoading: false,
    isFirstLoad: true,
    partnersError: null,
    searchQuery: null
}

const socialMarketPartnersSlice = createSlice({
    name: 'socialMarketPartners',
    initialState,
    reducers: {
        setSearchQuery: (state, action: PayloadAction<string>) => {
            state.searchQuery = action.payload || null
        }
    },
    extraReducers(builder) {
        builder
        .addCase(fetchTradingPartners.pending, (state) => {
            state.isLoading = false
        })
        .addCase(fetchTradingPartners.fulfilled, (state, action) => {
            state.isFirstLoad = false
            state.partnersError = null
            state.partners = action.payload
            state.isLoading = false
        })
        .addCase(fetchTradingPartners.rejected, (state, action) => {
            state.partnersError = action.payload as ErrorType ?? null
            state.isLoading = false
        })
    },
})

export default socialMarketPartnersSlice.reducer
export const { setSearchQuery } = socialMarketPartnersSlice.actions